// extracted by mini-css-extract-plugin
var _1 = "BugReportArrow__arrow--X4Y9f";
var _2 = "BugReportArrow__blueButton--r32i9";
var _3 = "BugReportArrow__close--iA7S7";
var _4 = "BugReportArrow__drag--XQoiU";
var _5 = "BugReportArrow__draggable--rQmrj";
var _6 = "BugReportArrow__instrSubmit--S3WgR";
var _7 = "BugReportArrow__instructions--m01A4";
var _8 = "BugReportArrow__left--AImOu";
var _9 = "BugReportArrow__right--v4uSo";
var _a = "BugReportArrow__submit--qZhpV";
var _b = "BugReportArrow__submitting--h2SqG";
export { _1 as "arrow", _2 as "blueButton", _3 as "close", _4 as "drag", _5 as "draggable", _6 as "instrSubmit", _7 as "instructions", _8 as "left", _9 as "right", _a as "submit", _b as "submitting" }
